import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useSubcontaListaFilters
 */

type State = {
    codigo?: string;
    descricao?: string;
    status?: number;
};

type Action = {
    setCodigo: (codigo: string | undefined) => void;
    setDescricao: (descricao: string | undefined) => void;
    setStatus: (status: number | undefined) => void;
    clearFilters: () => void;
};

export const useSubcontaListaFilters = create<State & Action>((set) => ({
    codigo: undefined,
    descricao: undefined,
    status: undefined,
    setCodigo: (codigo) => set({ codigo }),
    setDescricao: (descricao) => set({ descricao }),
    setStatus: (status) => set({ status }),
    clearFilters: () => set({
        codigo: '',
        descricao: '',
        status: 2,
    }),
}));

export const initialSubcontaListaFiltersValues: State = {
    codigo: '',
    descricao: '',
    status: 2,
};